var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIcon8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 11.9998V10.6665M7.99935 11.9998V9.99984M11.3327 11.9998V8.6665M1.66602 7.99984C1.66602 5.01428 1.66602 3.5215 2.59351 2.594C3.52101 1.6665 5.01379 1.6665 7.99935 1.6665C10.9849 1.6665 12.4777 1.6665 13.4052 2.594C14.3327 3.5215 14.3327 5.01428 14.3327 7.99984C14.3327 10.9854 14.3327 12.4782 13.4052 13.4057C12.4777 14.3332 10.9849 14.3332 7.99935 14.3332C5.01379 14.3332 3.52101 14.3332 2.59351 13.4057C1.66602 12.4782 1.66602 10.9854 1.66602 7.99984Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99414 7.65737C5.43087 7.70524 8.68875 7.48837 10.5418 4.54739M9.32755 4.19207L10.5779 3.99083C10.7303 3.97143 10.954 4.09174 11.009 4.23516L11.3396 5.32745",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon8);
export default __webpack_public_path__ + "static/media/SidebarIcon8.3bed6b706a0555161de6e4294304118b.svg";
export { ForwardRef as ReactComponent };